<script>
import { mapGetters, mapActions } from "vuex";

import appStatuses from "../../service/app-statuses.js";

import AdminAppShow from "../../components/AdminAppShow.vue";
import AdminAppShowEdit from "../../components/AdminAppShowEdit.vue";

import AppConfirm from "../../components/modals/app-confirm.vue";

import AdminContractPage from "../../components/AdminContractPage.vue";

import AdminContractSchetSummPage from "~/src/components/AdminContractSchetSummPage";

import BitrixResendButton from "../../components/BitrixResendButton.vue";

export default {
  components: {
    AdminContractSchetSummPage,
    AdminAppShow,
    AdminAppShowEdit,
    AppConfirm,
    AdminContractPage,
    BitrixResendButton,
  },

  data: () => ({
    tabs: {
      personal: "Personal info",
      edit: "Edit",
    },

    tab: "Personal info",

    loading: false,

    deleteDialog: false,

    isContract: false,

    isInvoice: false,

    pdfData: null,
  }),

  computed: {
    ...mapGetters("admin-applications", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",

    isQabulQiluvchi: (vm) => vm.user.role == "QABUL_QILUVCHI",

    isVerifierAdmin: (vm) => vm.user.role == "ADMIN_VERIFIER",

    // Bitrix kuzatuvchisi may edit applications EXCEPT accepted (Qabul qilingan) /
    // recommended (Tavsiya qilingan) ones — those stay read-only for this role.
    isBitrixObserver: (vm) => vm.user.role == "BITRIX_OBSERVER",

    // Who may push this record back to Bitrix: the super admin and the Bitrix kuzatuvchisi — the two
    // roles that own the CRM sync. Widening it is a one-line change here.
    canResendBitrix: (vm) => vm.isSupperAdmin || vm.isBitrixObserver,
    bitrixCanEdit: (vm) =>
      vm.isBitrixObserver &&
      !!vm.application &&
      vm.application.status !== "ACCEPTED" &&
      vm.application.status !== "PASSED",

    applicationStatus() {
      const status =
        appStatuses.find((x) => x.id == this.application.status) || {};

      const bg = color(status.id);
      const textColor = lightBg(status.id) ? "#1a1500" : "#fff";

      return {
        name: status[`name-${this.$i18n.locale}`],
        color: bg,
        textColor,
      };

      function color(statusName) {
        switch (statusName) {
          case "DRAFT":
            return "#F8D811";
          case "ACCEPTED":
            return "#8E44AD";
          case "PASSED":
            return "#16a34a";
          case "REJECTED":
            return "#dc2626";
          case "SUBMITTED":
            return "#F8D811";
          case "FAILED":
            return "#dc2626";
          case "EXAMINED":
            return "#1A0959";
          default:
            return "#667085";
        }
      }

      function lightBg(statusName) {
        return statusName === "DRAFT" || statusName === "SUBMITTED";
      }
    },

    applicantFullName() {
      const app = this.application;
      const parts = [app.lastName, app.firstName, app.middleName].filter(Boolean);
      return parts.join(" ") || "—";
    },
  },

  created() {
    const id = this.$route.params.id;
    if (id != this.application.id) {
      this.INIT_BY_ID({ id });
    }
  },

  methods: {
    ...mapActions("admin-applications", ["INIT_BY_ID", "DELETE_APPLICATION"]),

    ...mapActions("admin-application", ["INIT_APPLICATION"]),

    goBack() {
      this.$router.push("/applications");
    },

    onEdit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.edit;
      });
    },

    onStartEdit() {
      if (this.$refs.appShow && this.$refs.appShow.startEdit) {
        this.$refs.appShow.startEdit();
      }
    },

    onDelete() {
      this.loading = true;
      this.DELETE_APPLICATION(this.application).then((status) => {
        this.loading = false;
        if (status) {
          this.$router.replace("/applications");
        }
      });
    },

    async onDownloadContract() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract/dogovor/${id}`);
      if (data) {
        this.pdfData = data;
        this.$nextTick(() => (this.isContract = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoice() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract/invoice/${id}`);
      if (data) {
        this.pdfData = data;
        this.$nextTick(() => (this.isInvoice = true));
      } else {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div class="app-show-page pb-5">
    <admin-contract-page
      v-if="isContract && pdfData"
      :pdfData="pdfData"
      @close="
        () => {
          isContract = false;
          loading = false;
        }
      "
    />
    <admin-contract-schet-summ-page
      v-if="isInvoice && pdfData"
      :pdfData="pdfData"
      @close="
        () => {
          isInvoice = false;
          loading = false;
        }
      "
    />

    <app-confirm
      v-model="deleteDialog"
      :title="$t('Delete')"
      :text="$t('Do you really want to delete?')"
      :confirmText="$t('Yes, delete')"
      @accept="onDelete"
    />

    <!-- ── Back button ── -->
    <v-container style="display: flex; padding-top: 12px; padding-bottom: 0;">
      <v-btn
        @click="goBack"
        elevation="0"
        rounded
        large
        class="font-made modern-back-btn mb-6 px-6 py-3 d-flex align-center"
        style="
          border: 1px solid #e0e0e0;
          background: linear-gradient(135deg, #ffffff, #f9f9f9);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.25s ease;
        "
      >
        <v-icon
          left
          size="22"
          style="color:#0c0c0c; transition: transform 0.2s;"
          class="back-icon"
        >
          mdi-arrow-left
        </v-icon>
        <span
          class="font-weight-bold text-uppercase"
          style="letter-spacing:1px; font-size:14px; color:#0c0c0c;"
        >
          {{ $t("Back") }}
        </span>
      </v-btn>
    </v-container>

    <!-- ── Status Header Card ── -->
    <v-container>
      <div class="status-header">
        <div class="status-header-inner">
          <div class="status-info">
            <span class="status-label">{{ $t("Status") }}:</span>
            <span class="status-badge" :style="{ background: applicationStatus.color, color: applicationStatus.textColor }">{{ applicationStatus.name }}</span>
          </div>
          <div class="applicant-name">{{ applicantFullName }}</div>
        </div>
      </div>
    </v-container>

    <!-- ── Attribution card ──
         Shows who is behind this application, and its COLOUR signals who FILLED it:
         champagne brass (#c8a951) when a Qabul / Call-markaz operator created it at the /admission
         desk (application.filledBy set), dark navy (#0c1322) when the student registered themselves.
         Renders for a referral employee OR a desk filler, so the brass case actually appears —
         referral students self-fill, so filledBy is null and their card stays dark. -->
    <v-container
      v-if="application && (application.referralEmployee || application.filledBy)"
      class="py-0"
    >
      <div class="ref-by" :class="{ 'ref-by--filled': !!application.filledBy }">
        <div class="ref-by-glyph">
          <v-icon size="22">mdi-link-variant</v-icon>
        </div>
        <div class="ref-by-body">
          <template v-if="application.referralEmployee">
            <div class="ref-by-eyebrow">{{ $t("Referred by") }}</div>
            <div class="ref-by-name">{{ application.referralEmployee.fullName }}</div>
            <div
              class="ref-by-meta"
              v-if="application.referralEmployee.position || application.referralEmployee.phone"
            >
              <span v-if="application.referralEmployee.position">{{ application.referralEmployee.position }}</span>
              <span
                v-if="application.referralEmployee.position && application.referralEmployee.phone"
                class="ref-by-dot"
              >·</span>
              <span v-if="application.referralEmployee.phone">{{ application.referralEmployee.phone }}</span>
            </div>
          </template>
          <template v-else>
            <!-- Desk-filled with no referral employee: show the operator who filled it. -->
            <div class="ref-by-eyebrow">{{ $t("Filled by") }}</div>
            <div class="ref-by-name">{{ application.filledBy }}</div>
          </template>
        </div>
        <div class="ref-by-badge">
          {{ application.referralEmployee ? $t("Referral") : $t("Filled by") }}
        </div>
      </div>
    </v-container>

    <!-- ── Call-markaz manager (?manager_id=) ──
         Shown the same way as the referral Qabul xodim, so a student who came through a
         Call-markaz manager's link is attributed on this page too. Colour follows the same
         who-filled rule (yellow when a desk operator filled it). -->
    <v-container
      v-if="application && application.callManagerId"
      class="py-0"
    >
      <div class="ref-by" :class="{ 'ref-by--filled': !!application.filledBy }">
        <div class="ref-by-glyph">
          <v-icon size="22">mdi-headset</v-icon>
        </div>
        <div class="ref-by-body">
          <div class="ref-by-eyebrow">{{ $t("Call markaz xodimi") }}</div>
          <div class="ref-by-name">
            {{ application.callManagerName || ("Call markaz #" + application.callManagerId) }}
          </div>
        </div>
        <div class="ref-by-badge">{{ $t("Call markaz") }}</div>
      </div>
    </v-container>

    <!-- ── Taklif qilgan talaba (?student=) ──
         The student-referral channel, shown the same way as the two cards above. Independent of
         both: an applicant can have arrived through a student link, an employee link, a Call-markaz
         manager, or any combination, so this renders on its own condition. -->
    <v-container
      v-if="application && application.invitedByStudent"
      class="py-0"
    >
      <div class="ref-by" :class="{ 'ref-by--filled': !!application.filledBy }">
        <div class="ref-by-glyph">
          <v-icon size="22">mdi-school</v-icon>
        </div>
        <div class="ref-by-body">
          <div class="ref-by-eyebrow">{{ $t("Taklif qilgan talaba") }}</div>
          <div class="ref-by-name">{{ application.invitedByStudent.fullName }}</div>
          <div class="ref-by-meta" v-if="application.invitedByStudent.phone">
            <span>{{ application.invitedByStudent.phone }}</span>
          </div>
        </div>
        <div class="ref-by-badge">{{ $t("Talaba") }}</div>
      </div>
    </v-container>

    <!-- ── Tab Navigation + Content ── -->
    <v-container class="main-card-container">
      <div class="main-card">
        <div class="pa-5">
          <div header>
            <!-- Tab buttons with text + icon -->
            <div
              v-if="isSupperAdmin || isVerifierAdmin || isQabulQiluvchi || isBitrixObserver"
              class="tab-actions"
            >
              <v-btn
                :disabled="loading"
                elevation="0"
                @click="tab = tabs.personal"
                :class="['tab-btn', { 'tab-btn--active': tab === tabs.personal }]"
              >
                <v-icon left small>mdi-badge-account-outline</v-icon>
                {{ $t("Personal info") }}
              </v-btn>

              <v-spacer />

              <button
                v-if="isSupperAdmin || isQabulQiluvchi || bitrixCanEdit"
                :disabled="loading"
                class="edit-circle-btn"
                type="button"
                @click="onStartEdit"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.85 2.85 0 114 4L7.5 20.5 2 22l1.5-5.5Z"/><path d="m15 5 4 4"/></svg>
              </button>

              <v-btn
                v-if="isSupperAdmin || isQabulQiluvchi"
                :disabled="loading"
                elevation="0"
                class="delete-btn"
                @click="deleteDialog = true"
              >
                <v-icon size="22" color="#fff">mdi-trash-can</v-icon>
              </v-btn>

              <!-- Re-send THIS application's Bitrix requests, pushed to the far right of the action row
                   (verifies the phone's contact + deal in Bitrix first). -->
              <bitrix-resend-button
                v-if="canResendBitrix && application && application.id"
                class="bitrix-resend-slot"
                :application-id="application.id"
              />
            </div>

            <div class="position-relative">
              <v-progress-linear
                top
                absolute
                :active="loading"
                indeterminate
              />
            </div>

            <!-- Gradient divider -->
            <div class="gradient-divider" />
          </div>

          <div body class="pt-5">
            <admin-app-show ref="appShow" v-if="tab == tabs.personal" />
            <admin-app-show-edit v-else-if="tab == tabs.edit" />
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
$radius: 14px;
$line: #e6e8ec;

.app-show-page {
  min-height: 100vh;
}

/* ── Back Button ── */
.modern-back-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.modern-back-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.back-icon:hover {
  transform: translateX(-3px);
}

/* ── Status Header ── */
.status-header {
  background: #fff;
  border: 1px solid $line;
  border-radius: $radius;
  padding: 18px 24px;
}

.status-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.status-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-label {
  font-size: 14px;
  color: #667085;
  font-weight: 500;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
}

.applicant-name {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

/* ── Referred-by Qabul xodimi (special) ── */
.ref-by {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 14px;
  padding: 16px 20px;
  border-radius: $radius;
  background: linear-gradient(135deg, #0c1322 0%, #14203a 60%, #0c1322 100%);
  border: 1px solid rgba(255, 206, 74, 0.35);
  box-shadow: 0 10px 30px rgba(12, 19, 34, 0.18);
}
.ref-by::after {
  content: "";
  position: absolute;
  right: -40px;
  top: -60px;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(255, 206, 74, 0.18), transparent 70%);
  pointer-events: none;
}
.ref-by-glyph {
  position: relative;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #ffe07a, #f4a915);
}
.ref-by-glyph .v-icon {
  color: #1a1304 !important;
}
.ref-by-body {
  position: relative;
  flex: 1;
  min-width: 0;
}
.ref-by-eyebrow {
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: #ffce4a;
}
.ref-by-name {
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  margin-top: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ref-by-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 3px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.66);
}
.ref-by-dot {
  margin: 0 7px;
  opacity: 0.5;
}
.ref-by-badge {
  position: relative;
  flex-shrink: 0;
  align-self: flex-start;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #1a1304;
  background: #ffce4a;
  padding: 4px 10px;
  border-radius: 8px;
}

/* ── Filled-by-staff variant ──
   A Qabul / Call-markaz operator filled this application at the /admission desk. The card turns
   #544233 against the navy default. Both variants are dark, so this one separates itself by
   warmth rather than lightness, and carries white text with white glyph and badge chips. */
.ref-by--filled {
  background: #544233;
  border-color: rgba(255, 255, 255, 0.28);
  box-shadow: 0 10px 30px rgba(84, 66, 51, 0.35);
}
.ref-by--filled::after {
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1), transparent 70%);
}
.ref-by--filled .ref-by-glyph {
  background: #ffffff;
}
.ref-by--filled .ref-by-glyph .v-icon {
  color: #544233 !important;
}
.ref-by--filled .ref-by-eyebrow {
  color: #ffffff;
}
.ref-by--filled .ref-by-name {
  color: #ffffff;
}
.ref-by--filled .ref-by-meta {
  color: rgba(255, 255, 255, 0.75);
}
.ref-by--filled .ref-by-badge {
  color: #544233;
  background: #ffffff;
}

/* ── Main Card ── */
.main-card-container {
  padding-top: 12px;
}

.main-card {
  background: #fff;
  border: 1px solid $line;
  border-radius: $radius;
}

/* ── Tab Buttons ── */
.tab-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 16px;
}

/* flex-end for this one item: the tab buttons stay left, the Bitrix re-send is pushed to the right edge. */
.tab-actions .bitrix-resend-slot {
  margin-left: auto;
}

@media (max-width: 600px) {
  /* No room beside the tab buttons on a phone — give it its own full-width line. */
  .tab-actions .bitrix-resend-slot {
    margin-left: 0;
    width: 100%;
  }
}

.tab-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  border-radius: 10px !important;
  padding: 8px 16px !important;
  height: auto !important;
  background-color: #ffffff !important;
  color: #344054 !important;
  border: 1px solid #d0d5dd !important;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05) !important;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
}

.tab-btn:hover {
  background-color: #f9fafb !important;
  border-color: #c0c7d0 !important;
}

.tab-btn--active {
  background-color: #ffd451 !important;
  color: #1a1500 !important;
  border-color: #f5c542 !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}

.tab-btn--active:hover {
  background-color: #f5c542 !important;
}

/* ── Edit Button (circled pencil) ── */
.edit-circle-btn {
  width: 40px;
  height: 40px;
  min-width: 40px;
  padding: 0;
  border-radius: 50%;
  background-color: #7c3aed;
  border: 1px solid #6d28d9;
  box-shadow: none;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  outline: none;
}

.edit-circle-btn:hover {
  background-color: #6d28d9;
}

.edit-circle-btn:active {
  background-color: #5b21b6;
  transform: scale(0.97);
}

.edit-circle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Delete Button (circled trash) ── */
.delete-btn {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  background-color: #dc2626 !important;
  border: 1px solid #b91c1c !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background-color: #b91c1c !important;
}

.delete-btn:active {
  background-color: #991b1b !important;
  transform: scale(0.97);
}

/* ── Divider ── */
.gradient-divider {
  height: 1px;
  background: #e6e8ec;
  margin-top: 4px;
}

/* ══════════════════════════════════════════════════════════════
   Dark Mode
   ══════════════════════════════════════════════════════════════ */
.theme--dark .status-header {
  background: #1a1b23 !important;
  border-color: #2a2c3a !important;
}

.theme--dark .status-label {
  color: #8b8d9e !important;
}

.theme--dark .applicant-name {
  color: #e4e5eb !important;
}

.theme--dark .main-card {
  background: #1a1b23 !important;
  border-color: #2a2c3a !important;
}

.theme--dark .tab-btn {
  background-color: #22232e !important;
  color: #d5d6de !important;
  border-color: #33354a !important;
}

.theme--dark .tab-btn:hover {
  background-color: #2a2c3a !important;
}

.theme--dark .tab-btn--active {
  background-color: #ffd451 !important;
  color: #111318 !important;
  border-color: #ffd451 !important;
}

.theme--dark .tab-btn--active:hover {
  background-color: #ffdc6e !important;
}

.theme--dark .delete-btn {
  background-color: #dc2626 !important;
  border-color: #b91c1c !important;
}

.theme--dark .delete-btn:hover {
  background-color: #b91c1c !important;
}

.theme--dark .gradient-divider {
  background: #2a2c3a !important;
}

.theme--dark .modern-back-btn {
  background: linear-gradient(135deg, #22232e, #1a1b23) !important;
  border-color: #33354a !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3) !important;
}

.theme--dark .modern-back-btn span {
  color: #e4e5eb !important;
}

.theme--dark .modern-back-btn .back-icon {
  color: #e4e5eb !important;
}

.theme--dark .modern-back-btn:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.4) !important;
}
</style>
